export const authInitialState = {
  currentUser: null,
  token: localStorage.getItem('ACCESS_TOKEN'),
};
